/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const MARK_MOOD_TOOLTIP_AS_READ = 'MARK_MOOD_TOOLTIP_AS_READ'
export const markMoodTooltipAsRead = () => ({
  type: MARK_MOOD_TOOLTIP_AS_READ,
})

export const MARK_LANG_MODAL_AS_SHOWN = 'MARK_LANG_MODAL_AS_SHOWN'
export const markLangModalAsShown = () => ({
  type: MARK_LANG_MODAL_AS_SHOWN,
})
